<app-wizard-bar-nav [stepIsDirty]="false"> </app-wizard-bar-nav>

<div>
  <app-quote
    *ngIf="!(isSupplierManagerManualEntry() | async)"
    (offersActioned)="onAcceptOrRejectOffer($event)"
    [waitForLoadProfileCall]="generatingLoadProfileData"
  >
    <div quoteSettings *ngIf="generatingLoadProfileData" class="loadProfileStatusContainer">
      <em>Generating Load Profile Data for Quoting..</em>
      <mat-spinner diameter="18"></mat-spinner>
    </div>
  </app-quote>

  <app-add-quote
    [userIdentity]="user"
    [quoteRequestState]="quoteRequestState"
    [submitEvent]="submitSubject.asObservable()"
    *ngIf="this.user?.id === this.quote?.quoteRequestState?.ownerUserId && (isSupplierManagerManualEntry() | async)"
    (quoteSubmitted)="next()"
  ></app-add-quote>

  <app-custom-offer
    [rateCodes] = "rateCodes"
    [file]="file"
    [userIdentity]="user"
    [quoteRequestState]="quoteRequestState"
    [quoteRequestSummary]="quoteRequestSummary"
    [submitEvent]="submitSubject.asObservable()"
    *ngIf="this.user?.id !== this.quote?.ownerUserId && (isSupplierManagerManualEntry() | async)"
    (quoteSubmitted)="advanceToLastStep()"
  ></app-custom-offer>
</div>

<app-wizard-step-nav-buttons (backClicked)="back()" (nextClicked)="next()">
  <span nextButton>
    <button
      id="nextBtn"
      mat-flat-button
      color="accent"
      type="button"
      (click)="submitQuote()"
      [disabled]="isReadOnly"
      *ngIf="(isSupplierManagerManualEntry() | async) && quote?.prices.length === 0"
    >
      <i class="fa fa-paper-plane" aria-hidden="true"></i>
      Submit Quote
    </button>
    <button
      id="nextBtn"
      mat-flat-button
      color="accent"
      type="button"
      (click)="submitQuote()"
      [disabled]="isReadOnly"
      *ngIf="(isSupplierManagerManualEntry() | async) && quote?.prices?.length > 0"
    >
      Next
      <mat-icon matSuffix> navigate_next </mat-icon>
    </button>
  </span>
</app-wizard-step-nav-buttons>
